var a="\nvoid addLightMap() {\n    dDiffuseLight += dLightmap;\n}\n";export{a as default};
